import { useEffect, useState } from "react";
import { FileSpreadsheet, ShieldAlert } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { PageHeader } from "@/components/common/States";
import { api, apiError } from "@/lib/api";
import { download } from "@/lib/download";
import { ActivityFilters, emptyFilters, toParams } from "@/components/takip/ActivityFilters";
import { ActivityTable } from "@/components/takip/ActivityTable";
import { OnlineList } from "@/components/takip/OnlineList";
import { UserTracking } from "@/components/takip/UserTracking";

export default function Takip() {
  const [meta, setMeta] = useState(null);
  const [filters, setFilters] = useState(emptyFilters);
  const [tab, setTab] = useState("all");
  const [uid, setUid] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/takip/meta").then(({ data }) => setMeta(data)).catch((e) => toast.error(apiError(e))); }, []);
  const exportXlsx = async () => {
    setBusy(true);
    try { await download("/takip/activities.xlsx", toParams(filters), "takip_hareketler.xlsx"); } catch (e) { toast.error(apiError(e)); }
    setBusy(false);
  };
  const pick = (id) => { setUid(id); setTab("user"); };
  return (
    <div className="space-y-4 min-w-0" data-testid="takip-page">
      <PageHeader title="Takip" subtitle="Kullanıcı hareketleri: giriş/çıkış, sayfa görüntüleme, işlemler, dışa aktarma ve yazdırma" testid="takip-title">
        {tab === "all" && <Button variant="outline" disabled={busy} onClick={exportXlsx} data-testid="takip-export"><FileSpreadsheet className="h-4 w-4 mr-1 text-emerald-700" />{busy ? "Hazırlanıyor…" : "Excel"}</Button>}
      </PageHeader>
      <div className="grid gap-4 xl:grid-cols-[minmax(0,1fr)_280px] items-start">
        <Tabs value={tab} onValueChange={setTab} className="min-w-0">
          <TabsList><TabsTrigger value="all" data-testid="takip-tab-all">Tüm Hareketler</TabsTrigger><TabsTrigger value="user" data-testid="takip-tab-user">Kullanıcı Takibi</TabsTrigger></TabsList>
          <TabsContent value="all" className="space-y-3">
            <ActivityFilters meta={meta} value={filters} onApply={setFilters} />
            <ActivityTable params={toParams(filters)} />
          </TabsContent>
          <TabsContent value="user"><UserTracking meta={meta} uid={uid} setUid={setUid} /></TabsContent>
        </Tabs>
        <div className="space-y-3 xl:pt-12">
          <OnlineList onPick={pick} />
          <div className="panel p-3 text-[11px] text-slate-500 flex gap-2" data-testid="takip-kvkk"><ShieldAlert className="h-4 w-4 shrink-0 text-amber-600" />
            <span>Kullanıcı hareketleri güvenlik ve denetim amacıyla kaydedilir. Kayıtlar {meta?.retention_days || 365} gün saklanır ve silinemez.</span></div>
        </div>
      </div>
    </div>
  );
}
